export default __webpack_public_path__ + "static/media/caret-right-fill.97d8b6e0.svg";